module.exports = __webpack_public_path__ + "img/179.salad_bar.0dde0d5b.svg";